import createReducer from '../createReducer'
import {
  GET_USER_COURSES_SUCCESS,
} from './constants'

const initialState = {
  courses: [],
  noCoursesFound: false,
}

export default createReducer(initialState, {
  [GET_USER_COURSES_SUCCESS]: (state, action) => {
    const courses = action.payload.data.courses
    return {
      ...state,
      courses: courses,
      noCoursesFound: (courses.length === 0),
    }
  },
})



// WEBPACK FOOTER //
// ./src/services/courses/reducer.js